<template>
	<div class="gdeindx">
		<!-- ===========================================导航 -->
		<div class="Gheader"> 
			<div class="Gheader_login " v-if="kouling && kouling.length>0">
				<div class="flex ys-0 a-center" @click="$dakai('/user-Profile')">
					<span class="iconfont icon-renwu-ren" style="font-size: .2rem !important;"></span>
					<span class=" montserLight">{{$qu('yonghuming')}}</span>
				</div>
			</div>
			<div v-else class="Gheader_login ">
				<!-- <div class="Gheader_login_item" @click="$dakai('/proComOne')">
					<span class="iconfont icon-renwu-ren"></span>
					<span class=" montserLight">Register</span>
				</div>
				<div class="xiant Gheader_login_item"  @click="$dakai('/login_in')">
					<span class="iconfont icon-jinru"></span>
					<span class=" montserLight">Log in</span>
				</div> -->
				<div class="Gheader_login_item" @click="$dakai('/login_in')">
					<!-- <span>Log in with</span> -->
					<span>{{gudingziduan.shouye.toubu.loginsems}}</span>
					<span class="iconfont icon-Frame ml-5 montserLight"></span>
				</div>
			</div>
			<div class="Gheader_menu flex" :style="gunshang">
				<el-image @click="Shouye"
						:src="require('@/assets/pc/logo/logo.png')"
					class="logo" :class="menuindex == 1 ? 'guanbilogo' : ''"></el-image>
				<div class="Gheader_right_menu flex" >
					<div v-for="(l, i) in gudingziduan.shouye.toubu.list" class="tit-18 item montserRegular" @click="tiaoyemian(l)">
						{{ l.name }}
					</div>
				</div>
				<div class="Gheader_right_soubox flex">
					<div class="yuyan pl-20 pr-20 Gheader_right_soubox_item" style="position: relative;">

						<!-- 语言下拉 -->
						<el-dropdown placement="bottom" style="margin: 0;" @command="yuyandian">
							<div class="el-dropdown-link tit-16 montserRegular cur_pointer" style="color: #333; margin: 0;">
								<span class="iconfont icon-earth tit-16"></span>
								<span>{{yuyancode}}</span>
							</div>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item v-for="yuyan in yuyanlist" :command="yuyan.k">{{ yuyan.name }}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
						<!-- 语言下拉 end!!-->


					</div>
					<div class="xiant2 rel pl-20 pr-20 Gheader_right_soubox_item cur_pointer" @click="shousousuo">
						<span class="iconfont icon-sousuo1"></span>
					</div>
					<div class="btn Gheader_right_soubox_item cur_pointer">
						<div class="Gheader_right_bofan" @click="bofan">
						</div>
					</div>
				</div>
				<div class="iconfont  mini_right_menu" :class="menuindex == 1 ? 'icon-guanbi' : 'icon-caidan'"
					@click="Showmenu"></div>

				<!-- 搜索下拉 -->
				<div class="sjj_sou2" :class="souindex2 ? 'sou_show2' : ''">
					<div class="sjj_sou2_1 flex sjj_sou1" v-if="souindex2">
						<el-input @change="send" class="sjj_souinput" v-model="sousuo" placeholder="Please enter keyword..."
							placeholder-class="tit-16" placeholder-style="color:#333;"></el-input>
						<div class="iconfont icon-sousuo1 tit-26" style="color: #666666;" @click="send"></div>
					</div>
				</div>
				<!-- 搜索下拉 end!!-->
			</div>

			<!-- 移动端导航 -->
			<div class="sjj_nav" :class="menuindex ? 'nav_show' : ''" :style="gunshang2">
				<div class="sjj_nav_box">
					<!-- <div class="sjj_nav_tu">
						<el-image
							src="https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/eqB3WbLsRh8LBM7slG8QBwlB8HqpqP.png"
							class="sjj_nav_logo"></el-image>
					</div>
					<div class="sjj_nav_sousuo iconfont icon-sousuo1" @click="showsou"></div> -->
					<div>
						<!-- <div class="sjj_nav_item montserRegular" style="text-align: left;" @click="diankai">
							EN
						</div> -->
						<!-- <div v-if="xianshi2" class="t-center bsb-4" style="margin: auto;">
							<div class="">111</div>
							<div class="">22</div>
							<div class="">33</div>
						</div> -->
						<!-- <div class="sjj_nav_item" v-for="(l,index) in list">
							<div class="montserRegular">{{ l.name }}</div>
						</div> -->

						<el-menu v-for="(l,index) in gudingziduan.shouye.toubu.list2"  @open="handleOpens">
							<el-submenu v-if="l.menulist && l.menulist.length > 0" :index="l.url">
								<template slot="title">
									<span @click="handleMenuClick(l.url)">{{ l.name }}</span>
								</template>

								<el-menu-item @click="handleMenuClick(l2.url)" :index="l2.url" v-for="l2 in l.menulist">{{l2.name}}</el-menu-item>

							</el-submenu>
							<el-menu-item v-else :index="l.url" @click="handleMenuClick(l.url)">
								<span slot="title">{{ l.name }}</span>
							</el-menu-item>
						</el-menu>


					</div>
				</div>
			</div>
			<!-- 移动端导航 结束-->

			<div class="sjj_sou" :class="souindex ? 'sou_show' : ''">
				<div class="sjj_sou1 flex" v-if="souindex">
					<el-input class="sjj_souinput" v-model="sousuo" placeholder="Please enter keyword..."
						placeholder-class="tit-16" placeholder-style="color:#757575;"></el-input>
					<div class="iconfont icon-sousuo1 tit-26" style="color: #666666;"></div>
				</div>
			</div>

		</div>
		<!-- ===================================轮播 -->
		<div class="banner indexBanner">
			<div class="slideshow">
				<el-carousel :interval="3000" :height="bannerheight + 'px'" indicator-position="none">
					<el-carousel-item v-for="(t,i) in lunbolist">
						<h3 class="medium">
							<img ref="bannerheight" 
								:src="t.image"
								alt="" 
								@load="imgload" 
								@click="handleBannerClick(t.url)"
								v-if="t.image" 
								style="cursor: pointer"/>
							<!-- <img ref="bannerheight"
								:src="t.image"
								alt="" @load="imgload"  v-if="t.image"/> -->
							<!-- <img ref="bannerheight"
								src="https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/KPARl1pLaaG222rr28pRrrPkp88Rpp.jpg"
								alt="" @load="imgload" /> -->
						</h3>
					</el-carousel-item>
					<!-- <el-carousel-item>
						<h3 class="medium">
							<img ref="bannerheight"
								src="https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/KPARl1pLaaG222rr28pRrrPkp88Rpp.jpg"
								alt="" @load="imgload" />
						</h3>
					</el-carousel-item>
					<el-carousel-item>
						<h3 class="medium">
							<img ref="bannerheight"
								src="https://goodwe.hnydl.com.cn/gongyong/shangchuan/tu/33/2024/11/KPARl1pLaaG222rr28pRrrPkp88Rpp.jpg"
								alt="" @load="imgload" />
						</h3>
					</el-carousel-item> -->
				</el-carousel>
			</div>
		</div>
		<!-- ===========================================FORUM -->
		<!-- <router-link to="index3" tag="el-button" type="primary">Go to About</router-link> -->
		<div class="FORUM">
			<div class="w1500">
				<div class="tit-40 t-center B-700 tle wow fadeInUp montserBold">FORUM</div>
				<div class="flex FORUMbox j-between">
					<div class="ForumPost bj-0 ">
						<div class="pt-47  pb-22 container">
							<div class="flex w100 j-between ">
								<div class="tit-26 B-500 pl-38 smTit montserMedium">
									<!-- Popular Post -->
									{{gudingziduan.shouye.contant.PopularPost}}
								</div>
								<div style="color: #e81419;" class="pr-38">
									<span class="tit-16 B-400 more montserRegular" @click="$dakai('forum')">
										<!-- More -->
										{{gudingziduan.shouye.contant.More}}
									</span>
									<span class="iconfont icon-arrow-right"></span>
								</div>
							</div>
							<el-image :src="require('@/assets/pc/form2x.png')" class="Forum_dian"></el-image>
							<ul>
								<!-- title Releasetime commentNum thumbsUpNum latestReplyTime -->
								<li v-for="(l, i) in huatilie" class="cur_pointer pl-38 pr-38"
									@click="FORUM_xi(l.id)">
									<div class="liBox">
										<div class="flex j-between">
											<!-- pb-12 -->
											<div class="tit-20 B-300 tit montserLight line1">{{ l.title }}</div>
											<div class="icon">
												<span class="icon-pinglun1 iconfont tit-18 ys-9 "></span>
												<span class="tit-10 ys-9 pl-7 pr-16">{{ l.commentNum }}</span>
												<span class="icon-dianzan11 iconfont ys-9 tit-22"></span>
												<span class="tit-10 ys-9 pl-7">{{ l.thumbsUpNum }}</span>
											</div>
											<!-- <div class="tit-15 ys-9">{{l.Releasetime}}</div> -->
										</div>
										<div class="flex j-between flex-wrap pt-11">
											<div class="tit-15 ys-9 disc ">{{ l.createTime }} <el-divider
													direction="vertical"></el-divider>
													 <!-- Posted in -->
													{{gudingziduan.shouye.contant.postedin}}
													{{ l.groupName }}
											</div>
											<div class="tit-15 ys-9 disc " v-if="l.latestReplyTime">
												<span class="pr-10">{{gudingziduan.xinzengde.LastReply}}</span>
												<span>{{ l.latestReplyTime }}</span>
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<div class="ForumGroup">
						<div class=" bg-white bj-0">
							<div class="pt-47 pl-34 pr-33 pb-22">
								<div>
									<div class="tit-26 B-500 smTit montserMedium">
										<!-- Popular Group -->
										{{gudingziduan.shouye.contant.PopularGroup}}
									</div>
									<el-image :src="require('@/assets/pc/form2x.png')"
										class="Forum_dian Forum_dian2"></el-image>
								</div>
								<ul class="pt-36">
									<li v-for="(l, i) in Groups" v-if="i<=2" @click="onGro(l.id)"
										class="cur_pointer flex mb-20">
										<dd class="Groups_tu">
											<el-image :src="l.groupImage" class="" v-if="l.groupImage"></el-image>
										</dd>
										<dd class="Groups_contant pl-27">
											<em class="ftitle tit-20 B-300 montserLight">{{ l.groupName }}</em>
											<p class="tit-16 mr-18"><i class="ys-9 ">Posts:</i> <i class="clFF0013 pl-2 montserLight">{{l.invitationNum}}</i></p>
											<p class="tit-16"><i class="ys-9 ">Replies: </i><i class="clFF0013 pl-2 montserLight">{{l.replyNum }}</i></p>
										</dd>
									</li>
								</ul>
							</div>

						</div>
					</div>
				</div>
				<!-- width:13%;height:55px; t-center m-auto br-28  -->
				<div class="flex j-center wow fadeInUp">
					<div class="mt-75 mb-46 btn m-auto formBtn more1" @click="$dakai('forum')">
						<!-- Find out more -->
						{{gudingziduan.shouye.contant.findoutmore}}
					</div>
				</div>
			</div>

		</div>
		<div class="sanjiao"></div>
		<!-- Resource -->
		<Resource>
			<template v-slot:tle>
				<div class="f-42 B-700 t-center biaoti wow fadeInUp montserBold">{{gudingziduan.shouye.contant.Resource}}</div>
			</template>
			<template v-slot:tip>
				<i>|</i>
				<span class="tip ys-6 tit-18">Blog</span>
			</template>
			<template v-slot:btn>
				<div class="w100 t-center anniu pb-80 mt-70">
					<el-button type="primary more1 wow fadeInUp" @click="$dakai('LearningLab')">Find out more</el-button>
				</div>
			</template>
		</Resource>

		<!-- Resource end!!-->

		<div class="shuju rel indexThre" v-animate="'on'">
			<div class="fadeup shuju_nr" :class="leiming" @mouseleave="likai">
				<div class="sanjiao2"></div>
				<div class="t-center f-42 B-700 pt-70 mb-100 tle wow fadeInUp montserBold">
					<!-- JOIN GOODWE PLUS+ NOW! -->
					{{gudingziduan.shouye.contant.plusbt1}}
				</div>
				<div class="">
					<div class="shuju_nr1 m-auto w1500 flex j-between">
						<div class="shuju_li wow fadeInUp" data-wow-delay=".2s" @click="navigateToPlus('section1')">
							<div class="shuju_li1 flex column a-center j-center t-center">
								<div class="shuju_tu">
									<img src="../../assets/pc/goodw1.png" alt="" />
								</div>
								<div class="shuju_zi mt-29 mb-18 tit-26 montserRegular">
									<!-- Program Benefits -->
									{{gudingziduan.shouye.contant.plusbt11}}
								</div>
								<div class="shuju_zi2  w70 montserLight">
									<!-- The GoodWe PLUS+ membership comes with attractive benefits -->
									{{gudingziduan.shouye.contant.plusbt112}}
								</div>
								<el-button type="primary" class="mt-50 more1">{{gudingziduan.shouye.contant.plusbt113}}</el-button>
							</div>
						</div>
						<div class="shuju_li wow fadeInUp" data-wow-delay=".4s" @click="navigateToPlus('section2')">
							<div class="shuju_li1 flex column a-center j-center t-center">
								<div class="shuju_tu">
									<img src="../../assets/pc/goodw2.png" alt="" />
								</div>
								<div class="shuju_zi mt-29 mb-18 tit-26 montserRegular">
									<!-- Qualification Criteria -->
									{{gudingziduan.shouye.contant.plusbt12}}
								</div>
								<div class="shuju_zi2 w50 montserLight">
									<!-- Step-by-step to GoodWe PLUS+ qualification -->
									{{gudingziduan.shouye.contant.plusbt122}}
								</div>
								<el-button type="primary" class="mt-50 more1">{{gudingziduan.shouye.contant.plusbt123}}</el-button>
							</div>
						</div>
						<div class="shuju_li wow fadeInUp" data-wow-delay=".6s" @click="navigateToPlus('section3')">
							<div class="shuju_li1 flex column a-center j-center t-center">
								<div class="shuju_tu">
									<img src="../../assets/pc/goodw3.png" alt="" />
								</div>
								<div class="shuju_zi mt-29 mb-18 tit-26 montserRegular">
									<!-- Frequently Asked Questions -->
									{{gudingziduan.shouye.contant.plusbt13}}
								</div>
								<div class="shuju_zi2 w70 montserLight">
									<!-- Our FAQ section contains further details about the qualification process -->
									{{gudingziduan.shouye.contant.plusbt132}}
								</div>
								<el-button type="primary" class="mt-45 more1">{{gudingziduan.shouye.contant.plusbt133}}</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="shuju_nr2">
					<div class="bjImg"></div>
				</div>
				<div class="shuju_nr3"></div>
			</div>
		</div>

		<!-- ===========================================ABOUT  -->
		<div class="ABOUT w100 bj-0 pt-80 pb-40">
			<div class="w1290">
				<div class="tit-42 B-700 m-auto mb-87 t-center tle wow fadeInUp montserBold">
					<!-- ABOUT GOODWE SOLAR ACADEMY -->
					{{gudingziduan.shouye.contant.plusbt2}}
				</div>
				<div class="m-auto" style="position: relative;">
					<img :src="require('@/assets/pc/logo12x.png')" style="width:100%;">
					<div class="ABOUT_btn bj-0 cur_pointer" @click="bofans(1)"
						style="box-shadow: 0px 0px 68px 0px rgba(19,9,95,0.05);">
						<span class="icon-yousanjiao iconfont tit-24"
							style="color: #f34f3c;box-shadow: 0px 0px .68rem 0px rgba(243,79,60,0.05);"></span>
						<!-- <img :src="require('@/assets/pc/sanjiao.png')" style="width:.2rem;height:.2rem;"> -->
					</div>
				</div>
				<div class="t-center tit-18 ys-66 m-auto ABOUT_tishi montserLight">
					<!-- We are aiming to provide pre-sales support	beyond expectation and build an open platform for knowledge sharing and technical training in th<a href=""></a>e PV industry globally. -->
					{{gudingziduan.shouye.contant.plusbt21}}
				</div>
			</div>
		</div>
		<!-- 视频弹框 -->

		<div v-if="shipinindex" class="w100 videobox bj-0">
			<div v-if="shipinindex" class="w100 videozhe h100"></div>
			<div class="inBox" style="position: relative;">
				<div class="veoBox">
					<video ref="videoPlayer" style="width:100%; height:100%;" controls :src="qiye.aboutVideo" v-if="qiye.aboutVideo"></video>
				</div>
				<div class="iconfont icon-guanbi1" @click="bofans(0)"></div>
			</div>
		</div>


		<!-- ===========================================STAY  -->
		<div class="w100 bj-0 indexStay" style="position: relative;">
			<div class="STAY">
				<div class="f-42 ys-0 t-center w100 B-700 pt-152 tle wow fadeInUp montserBold">
					<!-- STAY IN THE LOOP! -->
					{{gudingziduan.shouye.contant.stayin}}
				</div>
				<div class="f-18 ys-0 t-center w100 B-300 mt-19 montserLight">
					<!-- Sign up for our newsletter. We won't spam you.	Just one update per month. -->
					{{gudingziduan.shouye.contant.stayin2}}
				</div>
				<div class="STAY-sign m-auto bj-0">
					<el-form ref="form" :model="mail" label-width="0px">
						<el-form-item>
							<div class="flex j-between" @click="sends">
								<el-input class="sjj_souinput" v-model="mail.emailAddress"
									:placeholder="gudingziduan.shouye.contant.stayin3" placeholder-class="tit-16"
									placeholder-style="color:#757575;"></el-input>
								<div class="btn bj-black cur_pointer t-center tit-18" >
									<!-- Submit -->
									{{gudingziduan.shouye.contant.stayin4}}
								</div>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<el-dialog title="" top="20vh" class="t-center dialogCode2" :visible.sync="Fasongemail">
				<div class=" ml-20 mr-20 ">
					<div class="">
						<div class="tit-28 ys-33 t-left">Subscribe to GoodWe Solar Community</div>
						<div class="tit-14 ys-66 t-left mb-30">Insert your details below to receive information</div>
					</div>
					<el-form ref="form" :model="emailshu" label-width="0px">
						<el-form-item>
							<div class="flex item">
								<div class="ProfileFrom-a2s z-E60012 mr-3">＊</div>
								<div class="ProfileFrom-a4s" >
									<el-input size="medium" class="userProfileinput" v-model="emailshu.takeName"
										placeholder="Enter your name" placeholder-class="tit-16"
										placeholder-style="color:##A1A1A1;"></el-input>
								</div>
							</div>
						</el-form-item>
						<el-form-item>
							<div class="flex item">
								<div class="ProfileFrom-a2s z-E60012 mr-3">＊</div>
								<div class="ProfileFrom-a4s" >
									<el-input size="medium" class="userProfileinput" v-model="emailshu.emailAddress"
										placeholder="Enter a valid email address" placeholder-class="tit-16"
										placeholder-style="color:##A1A1A1;"></el-input>
								</div>
							</div>
						</el-form-item>
						<el-form-item>
							<div class="flex item">
								<div class="ProfileFrom-a2s z-E60012 mr-3">＊</div>
								<div class="ProfileFrom-a4s" >
									<el-input size="medium" class="userProfileinput" v-model="emailshu.company"
										placeholder="Enter your company name" placeholder-class="tit-16"
										placeholder-style="color:##A1A1A1;"></el-input>
								</div>
							</div>
						</el-form-item>
						<el-form-item>
							<div class="flex item">
								<div class="ProfileFrom-a2s z-E60012  mr-3">＊</div>
								<div class="ProfileFrom-a4s">
									<el-input size="medium" class="userProfileinput" v-model="emailshu.countryOrRegion"
										placeholder="Enter your region" placeholder-class="tit-16"
										placeholder-style="color:##A1A1A1;"></el-input>
								</div>
							</div>
						</el-form-item>
						<el-form-item>
							<div class="flex item ">
								 <el-checkbox v-model="emailshu.checked" class="cascass"></el-checkbox>
								 <div class="mt-9 ml-4">I accept the <i class="z-E60012 xiahuaxian cur_pointer " @click="foottiao2('/userAgreement')">Terms of Use</i> And <i class="z-E60012 xiahuaxian cur_pointer" @click="foottiao2('/privateAgreement')">Privacy Policy</i></div>
							</div>
						</el-form-item>
					</el-form>
					<div slot="footer" class="dialog-footer flex j-center mt-40 pb-30">
						<div class="Profilesave2 tit-18 ys-0 B-500"  @click="save">Subscribe</div>
					</div>
				</div>
			</el-dialog>
		</div>
		
		<!-- ================foot -->
		<div class="Gsfoot w100 pb-28">
			<div class="w1500">
				<div class="flex j-between mb-93">
					<div class="foterlogo">
						<img :src="require('@/assets/logo2x.png')" class="mt-42">
					</div>
					<div class="f-menu" v-for="(f,i) in footdaohan">
						<div class="tit-19 ys-0 B-400 mt-36 mb-30 montserRegular">{{f.name}}</div>
						<div class="tit-16 ys-0 B-300 montserLight" v-for="(g,i) in f.footer"  @click="qudakai(g.url)">{{g.name}}</div>
					</div>
					<div class="f-menu">
						<div class="tit-19 ys-0 B-400 mt-36 mb-36 montserRegular">Follow Us</div>
						<div class="flex youtu-face" style="opacity: 1;">
							<img  @click="tiaowai(1)" :src="require('../../assets/youtube.png')" class="mr-14"
								style="width:.36rem;height:.36rem;">
							<img  @click="tiaowai(2)" :src="require('@/assets/facebook.png')" class="" style="width:.36rem;height:.36rem;">
							<!-- <div class="iconfont icon-youtubeyoutube7  ysE71018  mr-14"></div>
						<div class="iconfont icon--facebook ysE71018 "></div> -->
						</div>
					</div>
				</div>
				<div class="flex f-menu-xinxi">
					<div class="tit-16  ys-0 montserLight">Copyright © 2021 GoodWe Technologies Co.,Ltd</div>
					<div class="tit-16 ml-63 ys-0 mr-63 montserLight">Contact us:academy@goodwe.com</div>
					<div class="tit-16  ys-0 montserLight cur_pointer"> <i @click="foottiao2('/userAgreement')">Terms of use</i> <i class="ml-20 mr-20">|</i> <i 	@click="foottiao2('/privateAgreement')"> Privacy
							Policy</i>
					</div>
				</div>
			</div>
		</div>

		<!-- 回到顶部 -->
		<BackTop></BackTop>
		<!-- 回到顶部 -->
		<!-- cookie部分 -->
		<div class="he_cook" v-if="!consentGiven">
			<div class="he_cook_box">
				<div class="info">
					<div class="p1">This website uses cookies</div>
					<div class="text">
						We use cookies to personalise content and ads, to provide social
						medla features and to analvse our trafic. We also share
						information alboutyour use of our site with our social media,
						advertising and analytics partners who may combine it with other
						information that you've providedto them or that they've collected
						from your use of their services.
					</div>
					<div class="more_info" @click="foottiao2('/privateAgreement')">
						<span style="font-size: .16rem;font-weight: bold;">More info</span>
					</div>
				</div>
				
					
				<div class="he_cookc">
					<div class="he_cooknb he_cooknb1"  @click="onCustomize">
						<a href="javascript:;" class="getCookie">Customize</a>
					</div>
					<div class="he_cookmo" style="display: flex;">
						<div class="he_cooknb he_cooknb2" @click="acceptCookies">
							<a href="javascript:;" class="getCookie" >Allow all</a>
						</div>
						<div class="he_cooknb he_cooknb2" @click="rejectCookies">
							<a href="javascript:;" >Deny</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="Cookie preferences" class="cookebox" :visible.sync="dialogFormVisible">
			<div style="color: #ffffff;margin-bottom: 10px;">Cookie usage</div>
			<div style="color: #ffffff;margin-bottom: 10px;">GoodWe is using cookies to improve your user experience. By clicking ‘Accept all’ you consent that we can access, collect, store and use cookies and your IP address in accordance with our Cookie Policy</div>
		 
			<div class="xuanzz" style="display: flex;align-items: center;">
				<div @click="show1 =! show1" :class="show1==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show1 =! show1">Necessary</div>
				<el-switch disabled v-model="value1" active-color="#ff4949"> </el-switch>
			</div>
			<div v-if="show1" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Necessary cookies help make a website usable by enabling basic functions like page navigation and access to secure areas of the website. The website cannot function properly without these cookies.</div>
			
			<div class="xuanzz" style="display: flex;align-items: center;margin-top: 5px;">
				<div @click="show2 =! show2" :class="show2==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show2 =! show2">Performance and analytics</div>
				<el-switch v-model="value2" active-color="#ff4949"> </el-switch>
			</div>
			<div v-if="show2" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Performance cookies are used to understand and analyze the key performance indexes of the website which helps in delivering a better user experience for the visitors. Analytical cookies are used to understand how visitors interact with the website. These cookies help provide information on metrics such as the number of visitors, bounce rate, traffic source, etc.</div>
			<div v-if="show2" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">
				<div>Cookie table</div>
				<div style="display: flex;padding: 8px 0;color: #ffffff;font-weight: bold;">
					<div style="width: 20%">Cookie</div>
					<div style="width: 30%">Domain</div>
					<div style="width: 50%">Description</div>
				</div>
				<div class="xiaoguo" style="display: flex;padding: 8px 0;color: #ffffff;">
					<div style="width: 20%">_ga</div>
					<div style="width: 30%">goodwe.com</div>
					<div style="width: 50%">Identify user access</div>
				</div>
				<div class="xiaoguo" style="display: flex;padding: 8px 0;color: #ffffff;">
					<div style="width: 20%">_gid</div>
					<div style="width: 30%">goodwe.com</div>
					<div style="width: 50%">Differentiate user access sessions</div>
				</div>
			</div>
			
			<div class="xuanzz" style="display: flex;align-items: center;margin-top: 5px;">
				<div  @click="show3 =! show3" :class="show3==true?'rotateBottom':''" style="background: #d5dee2;border-radius: 50%;color: #2c2f31;font-weight: bold;box-sizing: border-box;font-size: 13px;width: 20px;height: 20px;display: flex;align-items: center;justify-content: center;"><span class="el-icon-arrow-down" style="font-size: 13px;"></span></div>
				<div class="" style="flex: 1;color: #fff;margin-left: 10px;" @click="show3 =! show3">Marketing</div>
				<el-switch v-model="value3" active-color="#ff4949"> </el-switch>
			</div>
			<div v-if="show3" style="border: 1px solid #dee4e9;color: #ffffff;border-top: none;padding: 14px;">Marketing cookies are used to provide visitors with customized advertisements based on the pages you visited previously and to analyze the effectiveness of the ad campaigns.</div>
			<div class="xiaoguo2" style="padding: 16px;color: #ffffff;margin-top: 20px;border: 1px solid transparent;border-radius: 3px;">
				<div style="font-weight: bold;margin-bottom: 8px;">More information</div>
				<div>For any queries in relation to our policy on cookies and your choices, please <i @click="tiaowai(5)" class="lianhoce"> contact us.</i></div>
			</div>
		  
		  <div slot="footer" class="dialog-footer" style="display: flex;justify-content: space-between;">
		    <el-button round type="danger" @click="baocun" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Save Choices</el-button>
		    <div class="btn2">
				<el-button round type="danger" @click="rejectCookies" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Reject All</el-button>
				<el-button round type="danger" @click="acceptCookies" style="background: linear-gradient(to left, #E60012, #FF7759) !important;">Accept All</el-button>
			</div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	// import wow from 'wowjs'
	// import Header from '@/zujian/pc/Header.vue'
	function debounce(func, wait) {
	let timeout;
	return function (...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => {
		func.apply(this, args);
		}, wait);
	};
	}
	import {
		guangao,
		forum,dibudaohan,
		resource,qiyexinxi
	} from '@/api/index.js';
	import {Youjiandingyue} from '@/api/resource.js';
	import Resource from '../../components/Resource.vue';
	import {
		allUser
	} from '@/api/user.js';

	export default {
		components: {
			Resource
		},
		data() {
			return {
				denglu: false,
				Fasongemail:false,
				footdaohan:[],
				emailshu:{
					takeName:'',
					emailAddress:'',
					company:'',
					countryOrRegion:''
				},
				wodeshu:{},
				qiye:{},
				list: [{
					name: 'Forum',
					url: 'forum'
				}, {
					name: 'LearningLab',
					url: 'LearningLab'
				}, {
					name: 'GoodWe Plus+',
					url: 'plus'
				}, {
					name: 'Points Mall',
					url: 'pointsMall'
				}],
				// 移动端栏目
				list2: [{
						name: 'Forum',
						url: '/forum'
					},
					{
						name: 'LearningLab',
						url: '/LearningLab',
						menulist: [{
							name: 'Video',
							url: '/video'
						}, {
							name: 'Blog',
							url: '/blog'
						}, {
							name: 'Webinar',
							url: '/webinar'
						}, {
							name: 'Calculator',
							url: ''
						}],
					},
					{
						name: 'GoodWe Plus+',
						url: '/plus'
					}, {
						name: 'Points Mall',
						url: '/pointsMall'
					}
				],

				lunbolist:[],
				yuyanlist: [{
					name: 'English',
					url: '',
					k: 'EN'
				}, {
					name: 'Português-Brazil',
					url: '',
					k: 'PT'
				}, {
					name: 'English-Pakistan',
					url: '',
					k: 'PK'
				}
				
				// , {
				// 	name: 'Türkçe',
				// 	url: '',
				// 	k: 'TN'
				// },
				],
				yuyancode:'EN',
				xianshi: 0,
				menuindex: 0,
				souindex: 0,
				bofanindex: 0,
				xianshi2: 0,
				souindex2: 0,
				shipinindex: 0, //播放视频
				xianyu: 0,
				sousuo: '',
				gunshang: '',
				gunshang2: '',
				leiming: '',
				bannerheight: "",
				mail: {},
				shu: [],

				// 论坛话题
				huatilie: [
				],
				Groups: [],
				sty: '',
				yonghuming: '',

				kouling: '',
				hoverStates: '', // 用于跟踪每个卡片的hover状态
				videoSource: "https://goodwe.hnydl.com.cn/gongyong/shangchuan/yinpin/33/2024/11/QW29t395sxilHdiF4868eVh6DH8XO9.mp4",
				gudingziduan:{},
				// cookie
				consentGiven: false,
				dialogFormVisible: false,
				show1: false,
				show2: false,
				show3: false,
				value1: true,
				value2: false,
				value3: false,
			}
		},
		created: function() {
			// if(this.$qu('yonghuming')=='' || this.$qu('yonghuming').length==0){
			// 登录请求、存口令值，用户名
			dibudaohan().then(s=>{
				if(s.code==401){
					location.reload();
				}else if(s.code==200){
					this.footdaohan=s.data.footer
				}
			})
			allUser().then(res => {
				if (res.code === 200) {
					this.wodeshu=res.data
					this.denglu=true
				} else {
					this.$cun('yonghuming', '')
					this.$cun('kouling', '')
					this.denglu=false
				}
			})
			// }else {111
			this.yonghuming = this.$qu('yonghuming')
			this.kouling = this.$qu('kouling')
			if(this.$qu('yuyancodes')!=[] && this.$qu('yuyancodes')!=''){
				this.yuyancode=this.$qu('yuyancodes')
				this.$store.commit('Gaiyuyan',this.$qu('yuyancodes'));
			}else{
				this.yuyancode=this.$store.state.yuyan
				this.$store.commit('Gaiyuyan', this.$store.state.yuyan);
			}
			this.gudingziduan=this.$store.state.cunyuanyan
			console.log(this.$qu('yuyancodes'))
			console.log(888)
			this.$cun('Tindex', '')
			guangao().then(s=>{
				this.lunbolist=s.data
			})
			forum().then(shu => {
				// console.log(shu)
				if (shu.code == 200) {
					this.huatilie = shu.data.hotTopics
					this.Groups = [];
					this.Groups = shu.data.hotGroups
				}
			})
			qiyexinxi().then(s=>{
				this.qiye=s.data
			})
		},
		// components: {
		// 	Header,
		// },
		onShow() {

		},
		mounted() {
			new this.$wow.WOW({
				live: false
			}).init()
			if(!this.$qu('kouling')){
				location.reload();
			}
			this.checkCookieConsent();
			window.addEventListener('resize', this.handleResize); // 添加事件监听器 
			window.addEventListener("resize", this.imgload, false);


			this.debouncedHandleScroll = debounce(this.handleScroll, 100);
			window.addEventListener('scroll', this.debouncedHandleScroll);
		},
		beforeDestroy() {
			window.removeEventListener('scroll', this.debouncedHandleScroll);

			window.removeEventListener("resize", this.imgload, false);
		},
		methods: {
			handleBannerClick(url) {
				if (url) {
				// 处理完整URL或相对路径
				const externalUrl = url.startsWith('https')? url: `https://community.goodwe.com${url}`;
				window.open(externalUrl, '_blank');
				}
			},
			onGro(id) {
				
				if(!this.denglu){
					this.$alert('Please log in first', '', {
					  confirmButtonText: 'Log in',
					  confirmButtonClass:'Loginanniu',
					  distinguishCancelAndClose:true,
					  center:true,
					  roundButton:true,
					  callback: action => {
						  if(action=='confirm'){
								this.$dakai('/login_in')
						  }
					  }
					});
					// this.$message({
					//   showClose: true,
					//   iconClass:'el-icon-warning',
					//   customClass:'my-error-message',
					//  dangerouslyUseHTMLString: true,
					//  message:'<strong><i style="margin-left:.1rem;">Please log in first</i> <a href="https://community.goodwe.com/login_in" style="color:red;margin-left:4px;text-decoration: none;">[here]</i> </strong>',
					//   type: 'error',
					//   offset:'350',
					//   duration:0
					// });
				}else{
					// this.$dakai('group?id='+id)
					this.$dakai('/forum/group/'+id)
				}
			},
			tiaowai(e){
				if(e==1){
					window.open('https://www.youtube.com/c/GoodWeSolarAcademy');
				}else if(e==5){
					window.open('https://emea.goodwe.com/contact-us');
				}else{
					window.open('https://www.facebook.com/GoodWeSolarAcademy');
					
				}
			},
			// cookies
			baocun() {
				this.$cun('Performance',this.value2)
				this.$cun('Marketing',this.value3)
				this.dialogFormVisible = false
				this.consentGiven = false;
			},
			onCustomize() {
				this.dialogFormVisible = true
			},
			// 以下为Cookie代码
			checkCookieConsent() {
				const consent = this.getCookie("cookie_consent");
				this.consentGiven = consent !== null;
			},
			acceptCookies() {
				this.setCookie("cookie_consent", "accepted", 30);
				this.consentGiven = true;
				this.dialogFormVisible = false
			},
			rejectCookies() {
				this.setCookie("cookie_consent", "rejected", 30);
				this.consentGiven = true;
				this.dialogFormVisible = false
			},
			setCookie(name, value, days) {
				const date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				const expires = "expires=" + date.toUTCString();
				document.cookie = `${name}=${encodeURIComponent(
					value
				)}; ${expires}; path=/; Secure; SameSite=Lax`;
			},
			getCookie(name) {
				const nameEQ = name + "=";
				const cookies = document.cookie.split(";");
				for (let i = 0; i < cookies.length; i++) {
					let cookie = cookies[i];
					while (cookie.charAt(0) === " ") {
						cookie = cookie.substring(1);
					}
					if (cookie.indexOf(nameEQ) === 0) {
						return decodeURIComponent(cookie.substring(nameEQ.length));
					}
				}
				return null;
			},
			qudakai(e){
				window.open(e);
			},
			navigateToPlus(sectionId) {
				this.$router.push({ path: '/plus', query: { section: sectionId } });
			},
			foottiao2(e){
				var urls='https://community.goodwe.com'+e
				window.open(urls);
			},
			handleOpens(e) {
				// console.log(e)
			},
			send(){
				this.$dakai('search?searchType=1&keyword='+this.sousuo)
			},
			handleMenuClick(url) {
				this.$router.push({
					path: url
				}); // 跳转到 Vue Router 中定义的路由  
			},
			imgload() {
				this.$nextTick(() => {
					if (this.$refs.bannerheight && this.$refs.bannerheight[0].width > 767) {
						this.bannerheight = this.$refs.bannerheight[0].height;
					} else this.bannerheight = 300
					// console.log(this.$refs.bannerheight[0].height,'11111111111111')
					// console.log(this.bannerheight, 'bannerheight')
				});
			},
			yuyandian(e) {
				this.yuyancode=e
				// console.log(e,'yuyandian')
				this.$cun('yuyancodes',this.yuyancode)
				this.$store.commit('Gaiyuyan', e);
				setTimeout(() => {
					// console.log(this.$store.state.cunyuanyan)
					this.gudingziduan=this.$store.state.cunyuanyan
				}, 600)
			},
			Shouye() {
				this.$router.push('/')
			},
			likai() {
				this.leiming = 'likai'
				setTimeout(() => {
					this.leiming = ''
				}, 600)
			},
			handleResize() {
				this.screenWidth = window.innerWidth; // 更新屏幕宽度  
				if (this.screenWidth >= 800) {
					this.sty = 'height: ' + (this.screenWidth / 1920) * 100 + 'vh'
				}
				if (this.screenWidth <= 1100) {
					this.xianshi = 1
				} else {
					this.xianshi = 0
					// console.log(11);

				}
			},

			tiaoddd() {
				this.$dakai('/index2');
			},

			handleScroll() {
				var that = this
				const scrollTop = window.scrollY; // 获取滚动位置  
				// console.log(that.xianshi)
				if (scrollTop > 50 && that.xianshi != 1) {
					that.gunshang = 'transform: translateY(-.6rem);width:100%;left:0; border-radius:0;box-shadow: 0px 2px 13px 6px rgba(0,0,0,0.15);z-index: 99999;background:#fff;'
					that.gunshang2 = 'transform: translateY(-.6rem);'
				} else {
					that.gunshang = 'transform: translateY(0);'
					that.gunshang2 = 'transform: translateY(0);'


				}
			},


			// HiAddClass()

			Showmenu() {
				this.menuindex = !this.menuindex
				this.souindex = 0
			},
			diankai() {
				this.xianshi2 = !this.xianshi2
			},
			showsou() {
				this.souindex = !this.souindex
			},
			shousousuo() {
				this.souindex2 = !this.souindex2
			},
			bofan() {
				// this.bofanindex = !this.bofanindex
				window.open('https://en.goodwe.com')
			},
			xuanyan() {
				this.xianyu = !this.xianyu
			},
			tiaoyemian(e) {
				this.$dakai(e.url)
				// this.$cun('Tindex', i)
				this.$cun('Menuindex', -1)
			},
			sends() {
				this.Fasongemail=true
				// 发送邮箱
				// this.$post('k=gudewei&c=mail', this.mail, function(s) {});
			},
			save(){				// 发送邮箱
				if (this.emailshu.takeName === '' || this.emailshu.emailAddress === '' ||  this.emailshu.company === '' ||    this.emailshu.countryOrRegion === '') {
				  // this.$message("Please complete the information before submitting");  
				  this.$message({
				    showClose: true,
					iconClass:'el-icon-warning',
					customClass:'my-error-message',
				    message: "Please complete the information before submitting",
				    type: 'error',
				    offset:'350',
					duration:0
				  });
				  return false; // 终止后续操作  
				} 
				if(this.emailshu.checked==true){
					Youjiandingyue({takeName:this.emailshu.takeName,emailAddress:this.emailshu.emailAddress,company:this.emailshu.company,countryOrRegion:this.emailshu.countryOrRegion}).then(shu=>{
						if(shu.code==200){
							this.Fasongemail=false
						}
						// this.$message(shu.message);
						this.$message({
						  showClose: true,
						  message:shu.message,
						  type: 'success',
						  offset:'350',
						  duration:0
						})
					})
				}else{
					// this.$message("Please check the box first");
					this.$message({
					  showClose: true,
					  iconClass:'el-icon-warning',
					  customClass:'my-error-message',
					  message:"Please check the box first",
					  type: 'error',
					  offset:'350',
					  duration:0
					})
				}
			},
			FORUM_xi(e) {
				// this.$dakai('details?id='+e)
				this.$dakai('/forum/details/'+e)
			},
			bofans(e) {
				this.shipinindex = e
				if(this.shipinindex==1){
					setTimeout(() => {
						const videoss = this.$refs.videoPlayer;
						if(e==1){
							videoss.play().catch(error => {});
						}else{
							videoss.pause();
						}
					},600);
				}
			},

		},
		// created: function () {
		// 	// console.log($('#app'));
		// },
	}
</script>

<style lang="scss" >
	body {
		background-color: #F6F6F8 !important;
	}
	.ProfileFrom-a2s{
		line-height:50px;
	}
	.ProfileFrom-a4s{
		width:96%;
		.el-input__inner{
			border:none;
			background-color: #f6f7f8;
			height:50px;
			line-height: initial;
		}
	}
	.lianhoce:hover{
		color:red;
		cursor: pointer
	}
	// 公用按钮效果
	.more1 {
		overflow: hidden;
		position: relative;
		background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
		z-index: 1;
	}

	.more1::after {
		content: "";
		position: absolute;
		border-radius: 100px;
		z-index: -1;
		width: 100%;
		height: 100%;
		left: 0;
		top: 0;
		background: linear-gradient(87deg, #e70a16 0%, #ff785c 100%);
		transform: scaleX(0);
		transform-origin: right;
		transition: transform .6s cubic-bezier(.785, .135, .15, .86);
	}
	.Profilesave2 {
		background-image: linear-gradient(4deg, rgb(255, 117, 88) 0%, rgb(230, 0, 18) 100%);
		color: #fff;
		padding: .12rem .45rem;
		border-radius: 100px;
		display: inline-block
	}
	.more1:hover::after {
		transform: scaleX(1);
		transform-origin: left;
		;
	}

	.Gheader {
		width: 89.3%;
		margin: 0 auto;
		position: fixed;
		top: 0px;
		left: 5%;
		z-index: 999;

		.xiant::after {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			width: 1px;
			height: 10px;
			opacity: 0.45;
			background: #ffffff;
			transform: translateY(-50%);
		}

		.xiant::before {
			content: '';
			position: absolute;
			right: 0;
			top: 50%;
			width: 1px;
			height: 10px;
			opacity: 0.45;
			background: #ffffff;
			transform: translateY(-50%);
		}

		.xiant2::after {
			content: '';
			position: absolute;
			left: 0;
			top: 50%;
			width: 1px;
			height: .15rem;
			opacity: 0.45;
			background: #C5C5C5;
			transform: translateY(-50%);
		}

		.Gheader_login {
			display: flex;
			justify-content: end;
			width: 89.3%;
			// padding:40px 0;
			position: fixed;
			top: 0;
			left: 5%;
			z-index: 9;
			height: .54rem;

			div:hover {
				cursor: pointer
			}
		}

		.Gheader_login_item {
			height: .54rem;
			line-height: .54rem;
			padding: 0 .23rem;
			color: #fff;
			box-sizing: border-box;
			// border-right: 1px solid #333;
			position: relative;
		}

		.iconfont {
			margin-right: 0.05rem;
			// font-size: .16rem;
		}

		.Gheader_menu {
			background: rgba(255, 255, 255, 0.8);
			width: 89.3%;
			height: .89rem;
			min-height: 65px;
			position: fixed;
			top: .54rem;
			left: 5%;
			z-index: 98;
			transition: all 0.6s;
			// transition:top 3 ease, width 0.2s ease,height 0.2s, background 0.3s ease; /* 添加过渡效果 */
			border-radius: .2rem;
			justify-content: space-between;

			.logo {
				margin-left: .48rem;
				display: flex;
				align-items: center;

				img {
					max-width: 2.02rem;
					height: .48rem;
				}
			}

			.Gheader_right_menu {
				margin-left: 5%;
				width: 40%;
				justify-content: space-between;

				.item {
					font-weight: 400;
					text-align: center;
					color: #333333;
					display: flex;
					align-items: center;
					position: relative;
					span-decoration: none;
					/* Remove default underline */
					color: black;
					/* span color */
				}

				.item::after {
					content: '';
					position: absolute;
					left: 0%;
					bottom: 0;
					width: 0;
					height: 2px;
					background-color: red;
					transition: width 0.4s ease;
				}

				.item:hover::after {
					width: 100%;
					/* Expand the underline on hover */
					left: 0;
					/* Move it to the left */
				}

				.item:hover {
					cursor: pointer
				}

				/* Optional: Style for active item */
				.active {
					color: red;
					/* Active link color */
				}
			}

			.Gheader_right_soubox {
				// width: 19%;
				justify-content: space-between;

				.Gheader_right_soubox_item {
					display: flex;
					align-items: center;
					font-weight: 400;
					color: #333333;
					padding: 0 .3rem;

					&.yuyan {padding-left: 0;}	
					&.btn {padding-left: 0;}

					.yuyanDown {
						position: absolute;
						top: 100%;
						background: #fff;
						width: 100%;
						padding: 0 .2rem;
						min-width: max-content;
						text-align: center;
						left: 50%;
						transform: translateX(-50%);

						div {
							padding: .1rem 0;
						}

						div:hover {
							color: #e70a16;
						}
					}

				}

				.Gheader_right_bofan {
					background: url('../../assets/pc/logo/logo2.png') no-repeat;
					background-size: 100% 100%;
					width: 1.35rem;
					height: .45rem;
					border-radius: .22rem;
				}
			}

			.mini_right_menu {
				display: none;
			}
		}


	}

	// 语言下拉样式修改
	.el-dropdown-menu__item:focus,
	.el-dropdown-menu__item:not(.is-disabled):hover {
		color: #fff;
		background: rgba(231, 10, 22, 1);
	}

	// ==============================
	.FORUM {
		.tle {
			padding: .65rem 0 .7rem;
			font-family: "montserBold";
		}

		.FORUMbox {
			.smTit {
				font-family: "montserMedium";
			}

			.Forum_dian {
				width: 62px;
				height: 6px;
				margin-top: .15rem;
				margin-left: .38rem;
			}

			.Forum_dian2 {
				margin-left: 0;
			}

			.ForumPost {
				width: 65%;
				border-radius: .2rem;

				ul li {
					transition: .5s;
					.liBox {padding-top: .22rem; padding-bottom: .25rem;}
				}

				li:not(:first-child) .liBox {
					border-top: 1px solid #DDDDDD;
					box-sizing: border-box;
				}

				ul li:hover {
					box-shadow: 0px 0px 18px 0px rgba(6, 0, 1, 0.08);
					position: relative;
					bottom: 1px;
					z-index: 2;
					border-color: transparent;
				}

				ul li:hover+li .liBox {
					border-color: transparent;
				}

				ul li .icon-pinglun1:hover,
				ul li .icon-dianzan11:hover {
					color: red;
				}

				.tit {
					font-family: "montserLight";
					font-weight: 300;
				}

				.disc {
					font-family: "montserLight";
					font-weight: normal;
				}

				.more {
					margin-right: .1rem;
				}
			}

			.ForumGroup {
				width: 33.1%;
				border-radius: 20px;
				overflow: hidden;

				ul li {
					width: 100%;
					align-items: center;

					.Groups_tu {
						width: 45.25%;
						border-radius: 10px;
						display: flex;

						.el-image {
							width: 100%;
							border-radius: 10px;

							img {
								transition: .5s;
							}
						}
					}

					.Groups_contant {
						flex: 1;
					}

					.ftitle {
						// margin-top: .1rem;
						margin-bottom: .2rem;
						display: -webkit-box;
						-webkit-box-orient: vertical;
						-webkit-line-clamp: 1;
						overflow: hidden;
						font-weight: 300;
						font-family: "montserLight";
					}

					em {
						display: block;
						color: #333;
					}

					p {
						font-family: "montserLight";
						display: inline-block
					}
				}

				ul li:hover .el-image img {
					transform: scale(1.05);
				}
			}
		}

		.formBtn {
			font-family: "montserLight";
			cursor: pointer;
		}


	}
	.column {
		flex-direction: column;
	}

	.shuju {
		overflow: hidden;
		background: #fff;
		z-index: 1;

		.tle {
			font-family: "montserBold";
		}

		img {
			width: 100%;
		}

		.el-button {
			border: 0;
			padding: .15rem .24rem;
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			border-radius: 28px;
			border-color: unset;
			font-family: "montserLight";
		}

		.shuju_nr {}

		.shuju_nr2 {
			margin-top: -.1rem;
			background: url('../../assets/pc/shuju_bj.png');
			background-size: cover;
			position: absolute;
			top: 0;
			left: 0;
			width: 0;
			height: 100%;
			transition: 3s;
			z-index: -1;
		}

		.shuju_nr:hover::after {
			transform: translateX(0%) !important;
			transition: all 0.6s;
		}

		.shuju_nr3 {
			margin-top: .7rem;
			height: 1.5rem;
			background: linear-gradient(to bottom right, transparent 50%, #fff 50%, #fff 100%);
			width: 100%;
			z-index: 5;
		}

		.likai.shuju_nr::after {
			transform-origin: right;
			transform: translateX(100%) !important;
			transition: all 0.6s;
		}

		.shuju_nr::after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(114deg, rgba(163, 163, 163, 0), rgba(163, 163, 163, .2) 30%, rgba(163, 163, 163, .3));
			transform-origin: left;
			will-change: transform;
			z-index: 4;
			transform: translateX(-100%) !important;
			z-index: -1;
		}

		.shuju_li {
			flex: 1;

			.shuju_tu {
				width: 1.18rem;
			}

			.shuju_zi2 {
				line-height: 1.7;
				font-family: "montserLight";
			}
		}


	}

	.sanjiao2 {
		height: 1.2rem;
		background: linear-gradient(to top left, transparent 50%, #fff 50%, #fff 100%);
	}

	.indexThre.on .shuju_nr2 {
		width: 100vw;
	}

	// ABOUT=========
	.ABOUT {
		width: 100%;
		align-items: center;

		.tle {
			font-family: "montserBold";
		}

		.ABOUT_btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 1rem;
			height: 1rem;
			border-radius: 50%;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		.ABOUT_tishi {
			width: 79%;
			margin-top: .6rem;
			margin-bottom: .4rem;
		}
	}


	.videobox {
		position: fixed;
		z-index: 9;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		box-sizing: border-box;

		.videozhe {
			background: rgba(0, 0, 0, 0.24);
			position: absolute;
			z-index: 1;
			top: 0;
			left: 0
		}

		.inBox {
			padding: 15%;
			box-sizing: border-box;
			padding-top: 20%;
			width: auto;
			height: auto;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 2;

			.veoBox {
				width: 100%;
				height: 100%;
				overflow: hidden;
				border-radius: .3rem;
				video {display: block;}
			}
		}

		.iconfont {
			color: #ffffff;
			position: fixed;
			top: 25%;
			z-index: 99999;
			right: 14%;
			font-size: 40px;
			cursor: pointer;
		}
	}

	// STAY==========
	.indexStay .STAY {
		background: url('../../assets/pc/logo11.png');
		background-size: 100% 100% !important;
		width: 100%;
		padding-bottom: 1.62rem;
		box-sizing: border-box;

		.el-form-item {
			margin-bottom: 0;
		}

		.tle {
			font-family: "montserBold";
		}

		.STAY-sign {
			width: 34%;
			border-radius: 34px;
			margin-top: .6rem;
			overflow: hidden;

			.btn {
				// width: 29%;
				border-radius: 34px;
				display: flex;
				align-items: center;
				justify-content: center;
				padding: 0;
				padding: 0 .61rem;
			}

			.el-input__inner {
				height: .68rem;
				line-height: .68rem;
				padding-left: .47rem;

				min-height: 50px;
			}
		}
	}

	// foot==========
	.Gsfoot {
		background: #404040;

		.f-menu {

			div:not(:first-child) {
				line-height: 34px;
				opacity: 0.68;
			}

			>div:hover {
				opacity: 1;
			}

			div {
				cursor: pointer;
			}

			.tit-19 {
				font-family: "montserRegular";
			}
		}

		div:hover {
			opacity: 1;
		}

		.f-menu-xinxi {
			div {
				opacity: 0.68;
			}

		}
	}

	// ==============
	.btn {
		padding: .19rem .42rem;
		color: #fff;
		border-radius: 55px;
		display: inline-block;
	}

	.clFF0013 {
		color: #FF0013;
	}

	.qi {
		margin: 0 11%;
	}

	.flex {
		display: flex;
	}

	.t-center {
		text-align: center;
	}

	.icon-duoyuyan {
		margin-right: 0.14rem;
	}

	.icon-sousuo1 {
		margin-right: 0.3rem;
	}

	.sjj_nav {
		position: fixed;
		z-index: 9;
		background: #fff;
		width: 100%;
		height: 0;
		line-height: 40px;
		right: 0;
		overflow: auto;
		overflow-x: hidden;
		transition: top ease 0.35s, height ease .4s;
		margin-bottom: 1rem;
	}

	.nav_show {
		// top: 65px;
		z-index: 9;
		height: 100vh;
	}

	.sjj_sou {
		position: fixed;
		z-index: 9999;
		width: 100%;
		height: 0px;
		// display: none;
		background: rgba(255, 255, 255, 0.7);
		border-radius: 20px;
		top: 108px;
		transition: height 0.1s ease;
		/* 添加过渡效果 */
		// transform: translateX(-50%);
		// border-top: 1px solid #dfdede;
		backdrop-filter: blur(20px);
		align-items: center;
	}

	.sjj_sou2 {
		position: absolute;
		z-index: 9;
		width: 100%;
		left: 0;
		height: 0px;
		// display: none;
		background: rgba(255, 255, 255, 0.7);
		border-radius: .2rem;
		top: 100%;
		transition: height 0.3s ease;
		/* 添加过渡效果 */
		// transform: translateX(-50%);
		// border-top: 1px solid #dfdede;
		backdrop-filter: blur(.2rem);
		align-items: center;

		.sjj_sou2_1 {
			margin-top: 0.31rem;
			transition: all 0.9s ease;
		}
	}

	.sou_show2 {
		height: 1.1rem;
		display: inherit;

		.sjj_sou2_1 {
			// display: inherit;
		}

	}

	.sjj_sou1 {
		// display: none;
		width: 50%;
		margin-left: 25%;
		box-sizing: border-box;
		border-bottom: 1px solid #dfdede;
		align-items: center;
		// margin-top:40px;
		// padding:15px 0;
		justify-content: space-between;

		.icon-sousuo1 {
			margin-right: 0.1rem !important;
		}
	}

	.sjj_nav_box {
		// margin: 0 10%;
		max-height: 100%;
		overflow-y: auto;

		.sjj_nav_item {
			border-bottom: 1px #ddd solid;
			position: relative;
			padding: .3rem 0;
			text-align: center;
			color: #666;

			&:last-child {
				border: 0;
			}
		}

		.el-menu {
			border-bottom: 1px solid #ddd;
			border-right: 0;

			.el-menu {
				border-bottom: 0;
			}

			&:last-child {
				border: 0;
			}
		}

		.el-menu-item:focus,
		.el-menu-item:hover {
			background: none;
		}

		.el-menu-item.is-active {
			color: #e70a16;
		}


		.el-submenu__title:hover {
			background: none;
		}
	}

	.sjj_souinput .el-input__inner {
		border: none !important;
		background: none !important;
	}

	.sjj_souinput input::placeholder {
		color: #666;
		font-family: "montserLight";
	}

	.xiala_menu {
		width: 100%;
		position: fixed;
		z-index: 97;
		height: 100vh;
		top: 94px;
		background: #fff;
		overflow: auto;
		overflow-x: hidden;
		transition: top ease 0.35s;
	}

	.xl_menu_conten {
		// background: pink;
	}

	.sjj_nav_tu {
		width: 100%;
		text-align: center;
		padding: 30px 0;
	}

	.sjj_nav_logo {
		width: 177;
		height: 42px;
	}

	.sjj_nav_sousuo {
		width: 50%;
		text-align: center;
	}

	.indexBanner {
		.slideshow {
			.el-carousel__item h3 {
				margin: 0;
			}

			.el-carousel__item h3 {
				// height: 100%;

				img {
					height: 100%;
					width: 100%;
					object-fit: fill;
				}
			}
		}

	}

	.f-menu-xinxi {
		flex-wrap: wrap;
	}
	.gdeindx .el-dialog {
		// background: #2A2A2D;
		.el-dialog__title {color: #fff;font-weight: bold;}
		.xuanzz {
			border: 1px solid #f0f4f7;border-radius: 3px;padding: 16px;
		}
		.xuanzz:hover {
		    background: linear-gradient(to left, #E60012, #FF7759) !important;
		    border-color: var(--cc-cookie-category-block-hover-border) !important;
		}
		.rotateBottom {
			transform: rotate(-180deg);
		  }
		.xiaoguo:hover { background: #888; }
		.xiaoguo2:hover {
		    border: 1px solid #f0f4f7 !important;
		}
		.el-button.is-round {
		    border-radius: 25px;
		    padding: 12px 23px;
			}
	}
	/* cookies */
	.cookebox .el-dialog{
		background: #2A2A2D;
	}
	.he_cook {position: fixed; z-index: 998; bottom: 0; width: 100%; background: #2A2A2D; padding: .1rem 0 .2rem;box-shadow: .1rem .1rem .1rem rgba(0, 0, 0, 1);color: #fff;}
	.he_cook .he_cook_box {width: 70%; margin: auto;}
	.he_cook .info {padding: .3rem .1rem 0 .1rem;}
	.he_cook .info .p1 {color: #fff; font-size: var(--font22);font-weight: 700;padding:  0 .13rem;}
	.he_cook .info .text {margin-top: .12rem;color: #fff;font-size: var(--font16);padding: 0 .13rem .11rem .13rem;}
	.he_cook .info .more_info  {
		
		padding:  .1rem .13rem;
		font-size: .12rem !important;
		line-height: 1.5 !important; 
		
		    font-weight: 600;
			span {color: red;	transition: background-size .25s, color .25s ease;
		background-image: linear-gradient(currentColor, currentColor);
		    background-position: 0 100%;
		    background-repeat: no-repeat;
			cursor: pointer;
		    background-size: 0 1px;}
	}
	.he_cook .info .more_info span:hover {
	    background-size: 100% 1px;color: red!important
	    
	}
	.he_cook .he_cookc {padding: .1rem .13rem;display: flex;justify-content: space-between;}
	.he_cook .he_cooknb a {
		text-decoration:none;
		// font-size: .14rem;
	}
	.he_cook .he_cooknb1 {
		cursor: pointer;
		background: #ddd;
		border-color: #ddd;
		font-size: var(--font18);
		display: flex;
		align-items: center;
		justify-content: center;
		height: .45rem;
		min-height: 36px;
		border-radius: 30px;
		width: auto;
		padding: 0 .2rem;
		text-align: center;
		a {color: #2c2f31;}
	}
	.he_cook .he_cooknb2 {
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 1.75rem;
		right: 2.25rem;
		background: linear-gradient(to left, #E60012, #FF7759);
		height: .45rem;
		min-height: 36px;
		font-size: var(--font18);
		margin-left: .4rem;
		text-align: center;
		border-radius: 30px;
		min-width: 120px;
	    padding-left: .2rem;
	    padding-right: .2rem;
		a {color: #ffffff;}
	}
	.he_cook .he_cooknb a:hover {
		
	}
	// .he_cook {position: fixed; z-index: 9; bottom: 0; width: 100%; background: #2A2A2D; padding: .5rem 0;box-shadow: .1rem .1rem .1rem rgba(0, 0, 0, 1);color: #fff;}
	// .he_cook .he_cookc {display: flex; justify-content: space-between;align-items: center;}
	// .he_cook .info {width: 65%;}
	// .he_cook .info .p1 {color: #fff; font-size: var(--font26);font-weight: 700;}
	// .he_cook .info .text {margin-top: .2rem;color: #fff;}
	// .he_cook .he_cooknb a {display: block; border: 2px solid #ff0013;color: #ff0013;font-weight: 700; padding: .13rem 1rem; box-sizing: border-box; transition: .5s;}
	// .he_cook .he_cooknb.he_cooknb1 {margin-top: .15rem;}
	// .he_cook .he_cooknb a:hover {background: #ff0013; color: #fff;}
	
	// ==========================================================================================================================================================================
	// 响应式
	// 手机端导航
	.Grpfoot .wrapBox {
		display: none;
		padding: .3rem 0;
	}
	
	.Grpfoot .wrapBox .item ul li {
		margin: .15rem 0;
	}
	
	.Grpfoot .wrapBox .flow {
		margin-top: .5rem;
	}
	
	.Grpfoot .wrapBox .flow dl {
		display: flex;
		margin-top: .3rem;
	}
	
	.Grpfoot .wrapBox .flow dl dd {
		width: 10%;
		margin-right: .5rem;
	}
	
	.Grpfoot .wrapBox .flow dl dd img {
		max-width: 100%;
	}
	
	@media screen and (max-width: 767px) {
		.Grpfoot .wrapBox {
			display: block;
		}
	
		.Grpfoot .box {
			display: none;
		}
	
		/* cookies */
		.he_cook .he_cook_box {width: 88%;}
		.he_cook .he_cookc {flex-wrap: wrap;}
		.he_cook .info {width: 100%;}
		.he_cookmo {width: 100%; display: flex; justify-content: center; margin-top: .3rem;}
		.he_cook .he_cooknb {margin: 0 .2rem;}
		.he_cook .he_cooknb.he_cooknb1 {margin-top: 0;}


		.cookebox .el-dialog {width: 100%; margin: 0 !important;}
		.cookebox  .el-dialog__footer{padding: 10px 0px 20px 10px;}
		.cookebox .dialog-footer {flex-wrap: wrap;}
		.cookebox .dialog-footer .btn2 {}
		.cookebox .dialog-footer .btn2 button {margin: 0; margin-right: .25rem;}
		.gdeindx .cookebox .el-dialog .el-button.is-round {padding: 12px 15px;}
	}
	// ==========================================================================================================================================================================
	// 响应式
	@media screen and (max-width: 1440px) {
		.shuju .shuju_li {position: relative; padding-bottom: 1rem;}
		.shuju .el-button {position: absolute;bottom: 0;}
		.FORUM .FORUMbox .ForumGroup ul li .Groups_tu {width: 42%;}
	}

	@media screen and (max-width: 1200px) {
		.FORUM .FORUMbox .ForumGroup ul li .ftitle {
			margin-bottom: .3rem;
		}
	}


	@media only screen and (max-width:1024px) {
		.Gheader {
			width: 100%;
			top: 0;
			left: 0;

			.Gheader_menu {
				z-index: 9998;
				width: 100%;
				background: #fff;
				border-radius: inherit;
				left: 0;
				z-index: 98;
				box-shadow: none !important;
				border-bottom: 1px solid #eee;

				.Gheader_right_menu {
					display: none !important;
				}

				.Gheader_right_soubox {
					padding-right: 1.5rem;
				}

				.mini_right_menu {
					display: inherit;
					position: absolute;
					right: 0;
					line-height: 65px;
					margin-right: 5%;
					top: 50%;
					transform: translateY(-50%);
					font-weight: 500;
					color: #000;
					font-size: var(--font24);
				}
			}
		}

		.Gheader {
			position: sticky;
		}

		.Gheader .Gheader_login {
			position: sticky;
			width: 100%;
			background: #fff;
			left: 0;
			border-bottom: 1px solid #eee;
			min-height: 30px;
		}

		.Gheader .Gheader_login_item {
			color: #333;
		}

		.Gheader .Gheader_menu {
			position: sticky;
		}

		.sjj_sou {
			border-radius: 0;
		}

		.sjj_sou2 {
			border-radius: 0;
		}

		.sou_show {
			height: 110px;
			display: inherit;
		}

		.sou_show2 {
			border-radius: 0;
			display: block;
		}

		.sjj_sou2 .sjj_sou2_1 {
			margin-top: 0rem;
		}
	}

	@media screen and (max-width: 991px) {
		.foterlogo {
			width: 100%;
			text-align: center;
		}

		.Gsfoot .f-menu {
			display: none;
		}
	}

	@media screen and (max-width: 767px) {
		.Gheader {
			position: sticky;
		}

		.Gheader .Gheader_menu {
			min-height: 60px;
			position: sticky;
		}
		
		.Gheader .Gheader_menu .Gheader_right_soubox {
			padding-right: .6rem;
		}

		.Gheader .Gheader_menu .mini_right_menu {font-size: var(--font30);}


		.videobox .inBox {padding: 5%;}
		.videobox .iconfont {top: 0%;right: 1%;font-size: 30px;}

		.sjj_sou1 {
			width: 90%;
			margin: 0 5%;
		}


		.indexBanner .el-carousel__item h3 {
			height: 100%;
		}

		.indexBanner .el-carousel__container {
			height: 150px !important;
		}

		.FORUM .FORUMbox {
			flex-wrap: wrap;
		}

		.FORUM .FORUMbox .ForumPost {
			width: 100%;
		}

		.FORUM .FORUMbox .ForumGroup {
			width: 100%;
			margin-top: .3rem;
		}

		.shuju .shuju_nr1 {
			flex-wrap: wrap;
		}

		.shuju .shuju_li {
			width: 100%;
			flex: none;
			margin-top: .5rem;
		}

		.sanjiao2 {
			height: auto;
		}

		.shuju .shuju_nr3 {
			height: auto;
		}

		.shuju .shuju_li {
			margin: 0.5rem 0;
		}

		.shuju .shuju_li .shuju_zi2 {
			width: 100%;
		}

		.shuju .shuju_nr::after {
			display: none;
		}

		.ABOUT .ABOUT_tishi {
			width: 100%;
		}

		

		.indexStay .STAY .pt-152 {
			padding-top: 1rem;
		}

		.indexStay .STAY {
			background: linear-gradient(87deg, #ff785c 0%, #e70a16 100%);
			padding-bottom: 1rem;
		}

		.indexStay .STAY .STAY-sign {
			width: 95%;
		}

		.indexStay {
			.dialogCode2 .el-dialog {width: 60%;background: #fff !important;}
			.STAY-sign {width: 96%;}
			.dialogCode2 .el-dialog {width: 95%;}
			.dialogCode2 .el-dialog__body {padding: 10px 15px;}
			.dialogCode2 .el-dialog__body > div.ml-20 {margin: 0;}
		}

		

}
</style>